import { useState } from "react";
import styled from "styled-components";
import { AiFillStar } from "react-icons/ai";

import { MdCallMade, MdCallReceived } from "react-icons/md";
import SendAFYA from "../../CHW/Home/Send/send";
import ReceiveAFYA from "../../CHW/Home/Receive/receive";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const Div = styled.div`
  .ratings {
    font-weight: 800;
    font-size: 2.5rem;
  }
  .ratings-container {
    border-radius: 12px;
  }
`;

export default function Navs() {
  const [send, setSend] = useState(false);
  const [receive, setReceive] = useState(false);

  const loggedInUserRating = useSelector(
    (state: RootState) => state.loggedInUser.data?.rating
  );

  const handleSend = () => {
    setSend(!send);
  };

  const handleReceive = () => {
    setReceive(!receive);
  };

  return (
    <Div className="px-4 mb-4">
      <section className="bg-[#073278] ratings-container text-white flex items-center justify-around px-2">
        <p className="ratings py-2">
          {loggedInUserRating?.practitioner > 0
            ? (loggedInUserRating?.practitioner / 5) * 100
            : 0}
          %
        </p>
        <p className="text-base">Quality Rating</p>
        <div className="flex">
          <AiFillStar
            color={loggedInUserRating?.practitioner >= 1 ? "#FBBC05" : "#FFF"}
            size={20}
          />
          <AiFillStar
            color={loggedInUserRating?.practitioner >= 2 ? "#FBBC05" : "#FFF"}
            size={20}
          />
          <AiFillStar
            color={loggedInUserRating?.practitioner >= 3 ? "#FBBC05" : "#FFF"}
            size={20}
          />
          <AiFillStar
            color={loggedInUserRating?.practitioner >= 4 ? "#FBBC05" : "#FFF"}
            size={20}
          />
          <AiFillStar
            color={loggedInUserRating?.practitioner >= 5 ? "#FBBC05" : "#FFF"}
            size={20}
          />
        </div>
      </section>

      <section className="flex mt-5 justify-between" style={{ width: "100%" }}>
        <div
          className="bg-[#E7EFFE] flex justify-around items-center py-4 px-4"
          style={{ width: "45%" }}
          onClick={handleSend}
        >
          <MdCallMade size={20} color="#4285F4" />
          <p className="dark:text-black">Send AFYA</p>
        </div>
        <div
          className="bg-[#E7EFFE] flex justify-around items-center py-3 px-4"
          style={{ width: "45%" }}
          onClick={handleReceive}
        >
          <MdCallReceived size={20} color="#4285F4" />
          <p className="dark:text-black">Receive AFYA</p>
        </div>
      </section>

      <div>{send && <SendAFYA setSend={setSend} send={send} />}</div>
      <div>
        {receive && <ReceiveAFYA setReceive={setReceive} receive={receive} />}
      </div>
    </Div>
  );
}
